<section>
  <!--<div><button type="button" class="btn btn-link" (click)="printMap()">Print</button></div>-->
  <!-- Here's the DIV that we inject the map into -->
  <!-- Keep aspect ratio and max-width in sync with code behind print function -->
  <div class="mapContainer" style="min-width:550px; max-width: 1250px; aspect-ratio: 2 / 1; overflow: visible; margin-left: auto; margin-right: auto">
    <div aria-hidden="true" id="mapViewNode" #mapViewNode></div>
  </div>
</section>
